import { render, staticRenderFns } from "./GroupElement.vue?vue&type=template&id=b8e7a16c"
import script from "./GroupElement.vue?vue&type=script&lang=js"
export * from "./GroupElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports